if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector('.js-results-container');
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector('.js-message-error');
      this.errorMessageText = this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      const searchDrawerContent = document.querySelector('.drawer__content--search');
      const searchSuggestions = document.querySelector('.search-drawer__suggestions');

      // 🔹 Input listener
      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if (window.innerWidth < 990) searchDrawerContent.style.height = 'auto';
            if (searchSuggestions) searchSuggestions.style.display = 'block';
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);

          if (window.innerWidth <= 990) searchDrawerContent.style.height = '100%';
          if (searchSuggestions) searchSuggestions.style.display = 'none';
        }, 300);
      });

      // 🔹 ESC to close
      this.input.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        if (!this.input.value) {
          if (this.drawer) this.drawer.parentElement.parentElement.toggleDrawer();
          return;
        }
        this.close();
      });

      // 🔹 Clear text
      this.btnClearText.addEventListener('click', e => {
        this.close();
        searchDrawerContent.style.height = 'auto';
        if (searchSuggestions) searchSuggestions.style.display = 'block';
      });
    }

    // ✅ Main search logic
    async getSearchResults(searchTerm) {
      try {
        // 1️⃣ Fetch full predictive layout (with popular searches, collections, etc.)
        const suggestResponse = await fetch(
          `${Shopify.routes.root}search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search`
        );

        if (!this.isOpen) return;
        if (!suggestResponse.ok) throw new Error(suggestResponse.status);

        const suggestText = await suggestResponse.text();
        const suggestDoc = new DOMParser().parseFromString(suggestText, 'text/html');
        const suggestSection = suggestDoc.querySelector('#shopify-section-predictive-search');

        // 🧩 Always re-render full predictive structure first
        if (suggestSection) {
          this.resultsContainer.innerHTML = suggestSection.innerHTML;
        }

        // 2️⃣ Fetch *only* real product results (search.ajax.liquid)
        const realResponse = await fetch(
          `${Shopify.routes.root}search?section_id=search-ajax&q=${encodeURIComponent(searchTerm)}&type=product`
        );

        if (realResponse.ok) {
          const realHTML = await realResponse.text();
          const realDoc = new DOMParser().parseFromString(realHTML, 'text/html');
          const realProducts = realDoc.querySelector('[data-predictive-search-results-products]');
          const productContainer = this.resultsContainer.querySelector('[data-predictive-search-results-products]');

          // ✅ Replace only the products area, keep collections & queries intact
          if (realProducts && productContainer) {
            productContainer.innerHTML = realProducts.innerHTML;
          }
        }

        // 3️⃣ Open dropdown again
        this.open();

        // 4️⃣ Re-init cart actions if needed
        document.querySelector('quick-cart-drawer')?.initTriggers();

      } catch (error) {
        console.error('❌ Predictive search error:', error);
        this.errorMessageText.textContent = error.message;
        this.errorMessageContainer.classList.remove('hidden');
      }
    }

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.removeAttribute('disabled');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.setAttribute('disabled', true);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
